var map = {
	"./ai_blue.png": 686,
	"./backend_blue.png": 9996,
	"./de/de.jpg": 3682,
	"./eb_v1/eb_v1.webp": 5011,
	"./est/est.webp": 6871,
	"./favicon.png": 5963,
	"./frontend_blue.png": 4056,
	"./header.png": 1972,
	"./hep/hep.jpg": 1034,
	"./hya/hya.webp": 9091,
	"./kalenuxer/kalenuxer.png": 6546,
	"./lamp/lamp.webp": 1073,
	"./mb/mb.jpg": 8922,
	"./morkoc/morkoc.webp": 6239,
	"./myp/myp.webp": 1611,
	"./preview.jpg": 9319,
	"./tables/tables.webp": 3683,
	"./tk/tk.jpg": 6698
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;